import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('vocala_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const wsId = localStorage.getItem('vocala_workspace_id');
  if (wsId) {
    config.headers['X-Workspace-Id'] = wsId;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('vocala_token');
      localStorage.removeItem('vocala_workspace_id');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export default api;
